<div class="workspace-details-container">
  @if (isComposite()) {
    <section
      class="composite-left-line-starter-container"
      >
      <div class="composite-left-line"></div>
      <div class="composite-spacer-div"></div>
    </section>
  }

  @for (activity of workspaceActivities; track activity) {
    <section
      [ngClass]="{ 'composite-main-panel-section': isComposite() }"
      >
      @if (isComposite()) {
        <div class="composite-left-line">
          <div class="composite-left-line-circle"></div>
        </div>
      }
      <mat-expansion-panel
        #expPanel
        class="workspace-details-panel"
        >
        <mat-expansion-panel-header
          class="workspace-details-panel-header"
          collapsedHeight="auto"
          expandedHeight="auto"
          >
          <div class="workspace-header-container">
            <!-- border -->
            <section class="workspace-border-section">
              <div
                class="workspace-border"
                [ngClass]="activity?.shortAssignableType"
              ></div>
            </section>
            <!-- main content -->
            <section class="workspace-header-main">
              <!-- workspace details general -->
              <section class="workspace-details-general">
                <div class="workspace-title">
                  <img
                    class="workspace-title-icon"
                    [src]="getIconPath(activity)"
                    alt="Workspace Assignable Type"
                    />
                  <div>
                    <span
                      class="data-label font-size-12px"
                      >Activity Type: (<span>{{
                      getTypeName(activity)
                      }}</span
                      >)</span
                      >
                      <h2 class="h2-value font-size-18px">
                        {{ getWorkspaceTitle(activity) }}
                      </h2>
                      @if (activity.startedAt) {
                        <p
                          class="workspace-started-p"
                          >
                          <span class="font-weight-600"
                            >Started at:
                          </span>
                          <span
                                            [innerHTML]="
                                                getDate(activity.startedAt)
                                            "
                          ></span>
                        </p>
                      }
                    </div>
                  </div>
                </section>
                <!-- workspace details specific -->
                <section class="workspace-details-specific">
                  <!-- Workspace Status & Completion Date -->
                  <section
                    class="workspace-sections workspace-details-status"
                    >
                    <div
                      class="workspace-sections-inner-wrapper"
                      >
                      <span class="data-label font-size-12px">
                        Completed Date
                      </span>
                      @if (activity?.completedAt) {
                        <span
                          class="data-value font-size-14px"
                                        [innerHTML]="
                                            getDate(activity.completedAt)
                                        "
                        ></span>
                      }
                      @if (!activity?.completedAt) {
                        <span
                          class="data-value font-size-14px"
                          >---</span
                          >
                        }
                      </div>
                    </section>
                    <!-- Preview -->
                    @if (userProfile?.roleLevel !== 5) {
                      <section
                        class="workspace-sections workspace-details-preview"
                        >
                        <div>
                          <!-- activity reset button -->
                          <div class="reset-button-container">
                            @if (
                              activity.assetTypeId ===
                              assetTypeIds.EBOOK_ACT
                              ) {
                              <p
                                >
                                Attempts:
                                {{
                                formatAttemptsCount(activity)
                                }}/{{
                                formatMaxAttempts(
                                activity?.maxAttempts
                                )
                                }}
                              </p>
                            }
                            <!-- Show practice attempts count -->
                            @if (
                              activity?.maxAttempts !== -1 &&
                              setPracticeAttemptsForDisplay(
                              true,
                              activity
                              )
                              ) {
                              <p
                                class="practice-attempts"
                                >
                                {{
                                setPracticeAttemptsForDisplay(
                                false,
                                activity
                                )
                                }}
                              </p>
                            }
                            @if (
                              activity.assetTypeId ===
                              assetTypeIds.EBOOK_ACT &&
                              maxAttemptsReached(activity)
                              ) {
                              <p
                                class="max-attempts-reached-warning"
                                >
                                This student has reached their max
                                attempts for this activity. You can
                                no longer reset the status. If
                                needed, please edit the Max Attempts
                                value above.
                              </p>
                            }
                            @if (
                              showResetButton(activity) &&
                              isComposite()
                              ) {
                              <button
                                type="button"
                                mat-raised-button
                                color="primary"
                                            [disabled]="
                                                disableResetButton(activity)
                                            "
                                            (click)="
                                                $event.stopPropagation();
                                                resetStatus(
                                                    activity.compositeTaskAssignmentID
                                                )
                                            "
                                >
                                Reset Activity
                              </button>
                            }
                          </div>
                        </div>
                      </section>
                    }
                  </section>
                </section>
              </div>
            </mat-expansion-panel-header>
            <!-- Extra Info Iframe (cog-tutor-report) -->
            <ng-template matExpansionPanelContent>
              <!--                <cog-tutor-report-->
              <!--                    [assignment]="activity"-->
              <!--                    [sectionID]="getSectionID(activity)"-->
              <!--                    [teacher-class]="teacher-class"-->
              <!--                    [userProfile]="userProfile"-->
              <!--                >-->
            <!--                </cog-tutor-report>-->
            @if (expPanel.expanded) {
              <view-assignment
                [assignment]="activity"
              ></view-assignment>
            }
          </ng-template>
        </mat-expansion-panel>
      </section>
    }
  </div>
